// extracted by mini-css-extract-plugin
export default {"headercontainer":"Header_headercontainer__S6m13","account":"Header_account__sbMgn","buttons":"Header_buttons__bn+Vm"};